import type { ProviderMatcher } from '../widgetMacroTypes.ts';

const MATCH_URL = 'tudou';
const VIDEO_ID_PATTERN = /v\/([^/]+)/;

export const matchTudou: ProviderMatcher = (url) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}
	const idMatch = VIDEO_ID_PATTERN.exec(url);
	const videoId = idMatch ? idMatch[1] : '';
	return {
		kind: 'deprecated',
		provider: 'Tudou',
		embedUrl: `//tudou.com/v/${videoId}&hl=en&fs=1`,
		width: '',
		height: '',
		hostLabel: 'flash-deprecated',
	};
};
